export enum Events {
  INIT = "init",
  CHANGE = "change",
  CLEAR = "clear",
  CLICK = "click",
  DRAG = "drag",
  DROP = "drop",
  FOCUS = "focus",
  KEY_DOWN = "keydown",
  KEY_PRESS = "keypress",
  KEY_UP = "keyup",
  LOAD = "load",
  ON_LOAD = "onLoad",
  SELECT = "select",
  PRE_SUBMIT = "preSubmit",
  SUBMIT = "submit",
  UNLOAD = "unload",
  ENABLED = "enabled",
  PREVIEW = "preview",
  POST_SUBMIT = "postSubmit",
  MOUNTED = "mounted",
  CREATED = "created",
  DOWNLOAD = "download",
}
